import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, timeout } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MarketplaceService {
    constructor(private http: HttpClient) { }

    private selectedMarketplaceSource = new BehaviorSubject<any>(null);
    selectedMarketplace$ = this.selectedMarketplaceSource.asObservable();

    getUserAllManagedAreas(baseUrl: string): Observable<any> {
        return this.http
            .get<any>(`${baseUrl}/user/admin/moderation-areas`)
            .pipe(
                timeout(10000),
                map(res => {
                    return res;
                }),
                catchError(error => {
                    throw error;
                })
            );
    }

    setMarketplace(value: any) {
        this.selectedMarketplaceSource.next(value);
    }

    getMarketplace() {
        return this.selectedMarketplaceSource.getValue();
    }
}
